import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";
import React from "react";

interface NumberDetailProps {
  label: string;
  value: number;
  info?: string;
}

const NumberDetail: React.FC<NumberDetailProps> = ({ label, value, info }) => {
  return (
    <div className="flex justify-between homepage-text-sm ">
      <div className="flex items-center gap-1">
        <span>{label}</span>
        {info && (
          <FontAwesomeIcon
            className="size-3.5 text-gray-400"
            icon={faCircleInfo}
          />
        )}
      </div>
      <div className="homepage-text-sm ">
        <p>{value}</p>
      </div>
    </div>
  );
};

export default NumberDetail;
